require('./bootstrap');

import 'livewire-sortable'

window.$ = require('jquery');

import tippy from 'tippy.js';

window.tippy = tippy;

import moment from 'moment';

window.moment = moment;

require('daterangepicker');

import * as FilePond from 'filepond';
window.FilePond = FilePond;

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
window.FilePond.registerPlugin(FilePondPluginFileValidateType);

import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;

import ApexCharts from 'apexcharts'
window.ApexCharts = ApexCharts;

import { createPopper } from '@popperjs/core';
window.createPopper = createPopper;

import Tagify from '@yaireo/tagify'
window.Tagify = Tagify;

// import grapesjs from 'grapesjs';
// window.grapesjs = grapesjs;
// import 'grapesjs-preset-newsletter';

import mask from '@alpinejs/mask'
Alpine.plugin(mask)

import Pikaday from 'pikaday';
window.Pikaday = Pikaday;

import * as JSPM from "jsprintmanager";
window.JSPM = JSPM;
window.APP_URL = window.APP_URL ? window.APP_URL : 'https://sparrowchms.com';
JSPM.JSPrintManager.license_url = window.APP_URL + "/jspm";


import { Editor, nodeInputRule } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { TextSelection } from 'prosemirror-state'
import { Node, mergeAttributes } from '@tiptap/core'
import CharacterCount from '@tiptap/extension-character-count'
import Placeholder from '@tiptap/extension-placeholder'
import Image from '@tiptap/extension-image'
import Link from '@tiptap/extension-link'
import BubbleMenu from '@tiptap/extension-bubble-menu'

import Croppie from 'croppie';
window.Croppie = Croppie;

import Tooltip from "@ryangjchandler/alpine-tooltip";
Alpine.plugin(Tooltip);

document.addEventListener('alpine:init', () => {

  const DataVariable = Node.create({
    name: 'dataVariable',
    content: 'text*',
    addOptions: {
      HTMLAttributes: {},
      text: '',
    },
    inline: true,
    group: 'inline',
    selectable: false,
    atom: true,
  
    parseHTML() {
      return [
        { 
          tag: 'span[class="data-variable"]', 
        },
      ]
    },
  
    renderHTML({ node, HTMLAttributes }) {
      let text = node.content.firstChild ? node.content.firstChild.text : '';
      return [
        'span', 
        mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {class: 'data-variable'}),
        text
      ]
    },
  
    addCommands() {
      return {
          addVariable: text => ({ chain }) => {
          this.options.text = text;
          console.log('text', text);
          return chain()
            .insertContent({ 
                type: this.name, 
                content: [
                  {
                    type: 'text',
                    text: text,
                  },
                ],
              })
            .run()
          }
      }
    },
  
    addInputRules() {
      return [
        // nodeInputRule(/^{(.?)}/, this.type),
      ]
    },
  });

  Alpine.data('setupEditor', (content) => {

    return {
      editor: null,
      content: content,
      updatedAt: Date.now(), // force Alpine to rerender on selection change
      characterCount: 0,
      showVariableWarning: false,
      inlineImage(url = null) {
        if(! url) url = window.prompt('URL')

        if (url) {
          Alpine.dispatch('tiptap-image', url);
        }
      },
      getText() {
          var tmp = document.createElement('div');
          tmp.innerHTML = this.content;
          
          return tmp.textContent || tmp.innerText;
      },
      openEventSearch() {
        let event = new Event("open-event-search");
        window.dispatchEvent(event);
      },
      openGroupSearch() { 
        let event = new Event("open-group-search");
        window.dispatchEvent(event);
      },
      handleEventSelect(event) {
        console.log(event);
        let event_model = event.detail;
        if(event_model && event_model.landing_page_url) 
          Alpine
            .raw(this.editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: event_model.landing_page_url, class: 'js-app-link' })
            .command(({ tr }) => {
              tr.insertText(event_model.name)
              return true
            })
            .unsetMark('link')
            .run()
            // .commands.setLink({ href: event_model.landing_page_url, text: 'Event', class: 'js-app-link' });
      },
      handleGroupSelect(event) {
        console.log(event);
        let event_model = event.detail;
        if(event_model && event_model.landing_page_url) 
          Alpine
            .raw(this.editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: event_model.landing_page_url, class: 'js-app-link' })
            .command(({ tr }) => {
              tr.insertText(event_model.name)
              return true
            })
            .unsetMark('link')
            .run()
            // .commands.setLink({ href: event_model.landing_page_url, text: 'Event', class: 'js-app-link' });
      },
      setEventLink(event_name, link) {
        Alpine
            .raw(this.editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: link, class: 'text-blue-600' })
            .command(({ tr }) => {
              tr.insertText(event_name)
              return true
            })
            .unsetMark('link')
            .run()
      },
      setGroupLink(group_name, link) {
        Alpine
            .raw(this.editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: link, class: 'text-blue-600' })
            .command(({ tr }) => {
              tr.insertText(group_name)
              return true
            })
            .unsetMark('link')
            .run()
      },
      setAllGroupLink(text, link) {
        Alpine
            .raw(this.editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: link, class: 'text-blue-600' })
            .command(({ tr }) => {
              tr.insertText(text)
              return true
            })
            .unsetMark('link')
            .run()
      },
      setLink() {
        const selection = Alpine.raw(this.editor).state.selection;
        const previousUrl = Alpine.raw(this.editor).getAttributes('link').href;
        let link = prompt('Please enter link here:', previousUrl);
        console.log('selection.empty', selection);
        if(link) {
          if(selection.empty) {
            Alpine
            .raw(this.editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: link })
            .command(({ tr }) => {
              tr.insertText(link)
              return true
            })
            .unsetMark('link')
            .run()
          }
          else 
            Alpine.raw(this.editor).commands.setLink({ href: link });
        } else {
           Alpine.raw(this.editor).commands.unsetLink()
        }
      },
      initElement(element, limit = 0, focus = false) {
        console.log('element', element, limit, focus);
        this.editor = new Editor({
          element: element,
          extensions: [
            StarterKit,
            DataVariable,
            Image.configure({
              inline: true,
              class: 'w-20',
            }),
            Link.configure({
              autolink: true,
              openOnClick: false,
              HTMLAttributes: {
                class: 'text-blue-600 cursor-pointer',
              },
            }),
            CharacterCount.configure({
              limit: limit,
            })
          ],
          autofocus: focus,
          content: this.content,
          onUpdate: ({ editor }) => {
            this.content = editor.getHTML()
            let text_content = this.getText();
            this.characterCount = text_content ? text_content.length : 0;
          },
          onSelectionUpdate: () => {
            this.updatedAt = Date.now()
          },
        });

        this.$watch('content', (content) => {
          // If the new content matches TipTap's then we just skip.
          if (content === editor.getHTML()) return
          //else update it
          editor.commands.setContent(content, false)
        })
      }
    }
  });

});

// window.setupEditor = function(content) {
  
// }

//Pikaday: code to automatically select a date 
//when month or year has been changed.
//Remember to push the pikaday object to window.pikadays array
//to make it work.
window.pikadayModifyDate = function(type, value_change) {
  var pik_obj;

  window.pikadays = window.pikadays || [];
  window.pikadays.forEach(element => {
    console.log('visible', element.isVisible());
    // identifying object
    if(element.isVisible()) pik_obj = element;
  });

  if(!pik_obj) return;

  let actual_date = pik_obj.getDate();

  console.log('actual date', actual_date)

  if(!actual_date) return;

  // Modify month or year
  if( 'month' == type ){
      actual_date.setMonth(value_change);
  }
  else{
      actual_date.setFullYear(value_change);
  }
  // Format for set to pikaday
  let year = 1900 + actual_date.getYear();
  let month = actual_date.getMonth()+1;
  pik_obj.setDate(year+'-'+month+'-'+actual_date.getDate());
}

setTimeout(() => {

  document.addEventListener('change',function(e) {
      // console.log(e, e.target, e.target.class)
      if(e.target && e.target.className == 'pika-select pika-select-year'){
          // console.log(e.target.value);
          pikadayModifyDate('year', e.target.value);
      }

      if(e.target && e.target.className == 'pika-select pika-select-month'){
          // console.log(e.target.value);
          pikadayModifyDate('month', e.target.value);
      }
  });
  
}, 1000);

Alpine.start();
